import { useContext } from "react"

import AuthDescriptorContext from "./Context"

export const useAuthDescriptor = () => useContext(AuthDescriptorContext)
